import React from 'react';
import { BudgetReview } from './pages/BudgetReview';
export function App() {
  return <BudgetReview data-id="element-0" />;
}